import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

type ProtectedRouteProps = {
  children: ReactNode;
  requiredDashboard: number;
};

const ProtectedRoute = ({
  children,
  requiredDashboard
}: ProtectedRouteProps) => {
  // Get dashboards from user data (adjust based on where you store user info)
  const userData = localStorage.getItem('dashboards');
  const userDashboards: number[] = userData
    ? userData.split(',').map(Number)
    : [];

  const hasAccess = userDashboards.includes(requiredDashboard);

  if (!hasAccess) {
    return <Navigate to='/no-access' replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
